export enum FolderTypeQueryState {
  Empty = "",
  Personal = "personal",
  Shared = "shared",
  OwnedByMe = "ownedByMe",
  SharedWithMe = "sharedWithMe",
  All = "all",
}

export interface VirtualFolderInfo {
  href: string;
  name: string;
}
